export default __webpack_public_path__ + "static/media/Layla 9781408325018.33e5bf6d.jpg";